import React, { useState } from 'react';
import {
  TextField,
  TextFieldProps,
  InputAdornment,
  IconButton,
} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';

export type PasswordFieldWithSideToggleProps = Omit<
  TextFieldProps,
  'type' | 'InputProps' | 'SelectProps'
> & {
  /** dense フォームではトグルボタンを小さく表示 */
  density?: 'dense' | 'normal';
};

/**
 * outlined パスワード欄に表示／非表示トグルを付与する。
 * トグルは InputAdornment 内に置き、入力枠と縦位置がずれないようにする。
 */
const PasswordFieldWithSideToggle: React.FC<PasswordFieldWithSideToggleProps> = ({
  density = 'normal',
  sx,
  disabled,
  ...textFieldProps
}) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <TextField
      {...textFieldProps}
      type={showPassword ? 'text' : 'password'}
      disabled={disabled}
      fullWidth
      variant="outlined"
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label={showPassword ? 'パスワードを隠す' : 'パスワードを表示'}
              onClick={() => !disabled && setShowPassword((v) => !v)}
              onMouseDown={(e) => e.preventDefault()}
              edge="end"
              disabled={disabled}
              size={density === 'dense' ? 'small' : 'medium'}
            >
              {showPassword ? (
                <VisibilityOff sx={{ color: '#666666' }} />
              ) : (
                <Visibility sx={{ color: '#666666' }} />
              )}
            </IconButton>
          </InputAdornment>
        ),
      }}
      sx={sx}
    />
  );
};

export default PasswordFieldWithSideToggle;
